module.exports = __webpack_public_path__ + "static/media/au.ac7ddaca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/au.svg
// module id = 54
// module chunks = 0